import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import RegisterItAssetLayer from '../components/RegisterItAssetLayer'

const RegisterItAssetPage = () => {
  return (
    <MasterLayout>
        <Breadcrumb title='Register New Asset' />
        <RegisterItAssetLayer />
    </MasterLayout>
  )
}

export default RegisterItAssetPage

